import React from 'react';

import { infoMessage } from '../../../hooks/useNotifications';

interface PlanProps {
  title: string;
  originalPrice: string;
  discountedPrice: string;
  billing: string;
  features: string[];
  isPopular?: boolean;
  discount?: string;
  showLaunchOffer?: boolean;
}

const PricingCard: React.FC<PlanProps> = ({
  title,
  originalPrice,
  discountedPrice,
  billing,
  features,
  isPopular,
  discount,
  showLaunchOffer
}) => {
  return (
    <div
      className={`relative sm:w-5/12 bg-white rounded-xl shadow-lg p-6 ${
        isPopular ? 'border-4 border-green-500' : 'border-2 border-gray-200'
      }`}
    >
      {isPopular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-green-500 text-white text-sm font-semibold px-6 py-1 rounded-full">
          Best Value
        </div>
      )}

      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold text-gray-800 mb-2">{title}</h3>
        <div className="flex items-baseline justify-center space-x-2">
          <span className="text-gray-500 line-through">₹{originalPrice}</span>
          <span className="text-4xl font-extrabold text-gray-900">₹{discountedPrice}</span>
          <span className="text-gray-500">/{billing} + 18% GST</span>
        </div>

        {discount && <p className="text-green-600 font-medium mt-2">Save {discount}</p>}

        {showLaunchOffer && <div className="mt-1 text-sm text-[#FF543E] font-semibold">Launch Offer</div>}
      </div>

      <ul className="mb-8 space-y-3">
        {features.map((feature, index) => (
          <li key={index} className="flex items-center text-gray-600">
            <svg
              className="w-5 h-5 mr-2 text-green-500 flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            {feature}
          </li>
        ))}
      </ul>

      <button
        className={`w-full py-3.5 px-6 text-lg font-semibold rounded-lg transition-colors bg-[#0ACE82] hover:bg-green-600 text-white`}
        onClick={() => {
          infoMessage(
            <p className="text-2xl bg-green-50">
              Currently we are collecting all payments offline. <br />
              <a
                href={`https://wa.me/+917093303858?text=Hi,%0AI wanted to enquire about the ${title} listed in ${window?.location?.origin}.`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-700 underline"
              >
                Click Here
              </a>{' '}
              for more details
            </p>
          );
          // window.open(
          //   `https://wa.me/+917093303858?text=Hi,%0AI wanted to enquire about the ${title} listed in ${window?.location?.origin}.`,
          //   '_blank',
          //   'noopener,noreferrer'
          // );
        }}
      >
        Pay Now
      </button>
    </div>
  );
};

const Pricing = () => {
  const features = [
    'Custom Domain Website',
    'Unlimited Events Listing',
    'Unlimited Bookings',
    '0% Commission on Sales'
  ];

  return (
    <section id="pricing" className="bg-gray-50 pt-20 px-6">
      <div className="bg-gray-50 flex flex-col items-center justify-center">
        <h2 className="text-center md:text-left text-lg font-semibold mb-8 text-[#FF543E]">PRICING</h2>

        <div className="sm:flex flex-wrap justify-center items-stretch w-full space-y-6 sm:space-y-0 sm:space-x-6">
          <PricingCard
            title="Monthly Plan"
            originalPrice="1,500"
            discountedPrice="1,000"
            billing="month"
            features={features}
            discount="33%"
            showLaunchOffer={true}
          />

          <PricingCard
            title="Yearly Plan"
            originalPrice="18,000"
            discountedPrice="9,000"
            billing="year"
            features={features}
            isPopular={true}
            discount="50%"
            showLaunchOffer={true}
          />
        </div>
      </div>
    </section>
  );
};

export default Pricing;
